import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "printer",
  "use": "printer-usage",
  "viewBox": "0 0 18.82 18.82",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.82 18.82\" id=\"printer\"><path d=\"M17.677 5.311H1.146C.514 5.311 0 5.824 0 6.456v6.562c0 .137.112.25.251.25h2.687a.25.25 0 00.25-.25V9.286h12.446v3.732c0 .137.111.25.25.25h2.684a.252.252 0 00.252-.25V6.456a1.146 1.146 0 00-1.143-1.145zM2.785 8.117a.753.753 0 110-1.506.753.753 0 010 1.506zm13.431-.397h-3.955V6.695h3.955V7.72z\" /><path d=\"M13.37 16.99H7.609l-2.171.014V10.09h-1.3v7.043s-.048 1.08 1.062 1.08h8.561c.818 0 .924-.623.924-1.395V10.09h-1.299l-.016 6.9z\" /><path d=\"M6.078 11.961h6.547v1.131H6.078zM6.138 14.521h6.548v1.131H6.138zM5.337 1.862h8.031v2.736h1.254v-2.88c0-.613-.498-1.111-1.111-1.111H5.194c-.613 0-1.111.499-1.111 1.111v2.88h1.255l-.001-2.736z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/printer.svg
// module id = Uk3s
// module chunks = 1